import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import styles from './AnimatedTextLoader.module.css';

const AnimatedTextLoader = ({ text, speed = 0.3 }) => {
  const letters = Array.from(text);

  // Animation Variants
  const waveVariants = {
    hidden: { y: 0 },
    visible: (i) => ({
      y: [0, -8, 0], // Wave effect: up and down
      transition: {
        delay: i * speed,
        duration: 0.6,
        repeat: Infinity,
        repeatType: 'loop',
      },
    }),
  };

  return (
    <div className={styles.loaderContainer}>
      {letters.map((letter, index) => (
        <motion.span
          key={index}
          custom={index}
          variants={waveVariants}
          initial="hidden"
          animate="visible"
          className={styles.letter}
        >
          {letter}
        </motion.span>
      ))}
    </div>
  );
};

AnimatedTextLoader.propTypes = {
  text: PropTypes.string.isRequired,
  speed: PropTypes.number,
};

export default AnimatedTextLoader;
